<template>
  <div id="gang-sheet-builder-modal-body" class="modal gang-sheet-builder-modal" />
</template>

<script>
import { mapActions, mapState } from "pinia";
import { isProduction } from "common/utils/env";
import { readCookie } from "common/utils/cookie";
import { useDtfStore } from "./store";

export default {
  name: "GangSheetBuilder",
  computed: {
    ...mapState(useDtfStore, [
      "gangSheetBuilder",
      "gangSheetBuilderShopId",
      "gangSheetBuilderSizes"
    ]),
    builderPayload() {
      const payload = {
        container: "gs-builder", // optional - id of the element for the modal to be rendered in.
        mode: isProduction ? "production" : "development",
        shop_id: this.gangSheetBuilderShopId,
        size_id: 3,
        sizes: this.gangSheetBuilderSizes,
        settings: {
          nameAndNumber: {
            enabled: true
          }
        }
      };

      const customerId = readCookie("gangsheet_builder_customer_id");
      console.log("[GangSheetBuilder] <", customerId, ">");

      if (customerId) {
        payload.customer = { id: customerId };
      }

      return payload;
    }
  },
  async mounted() {
    this.showBuilder();
  },
  methods: {
    ...mapActions(useDtfStore, ["setShowGangSheetBuilder", "setGeneratedGangSheets"]),
    ...mapActions(useDtfStore, ["addFilesToQueue"]),
    showBuilder() {
      this.gangSheetBuilder
        .open(this.builderPayload)
        .on("design:created", gangSheetData => {
          this.processGangSheet(gangSheetData.data);
          this.gangSheetBuilder.close();
          this.setShowGangSheetBuilder(false);
        })
        .on("closed", () => {
          this.setShowGangSheetBuilder(false);
        });
    },
    async processGangSheet(gangSheetData) {
      const { designs } = gangSheetData;

      this.setGeneratedGangSheets(designs);

      const gangSheets = await Promise.all(
        designs.map(async design => {
          const downloadedGangSheet = await this.downloadGangSheetPreview(design);

          if (downloadedGangSheet) {
            return new File([downloadedGangSheet], `${design.id}.png`, { type: "image/png" });
          }

          return null;
        })
      );

      this.addFilesToQueue({
        files: gangSheets,
        artworkIndex: null,
        existingArtworkId: null
      });
    },
    async downloadGangSheetPreview(design) {
      let downloadedGangSheet = null;

      try {
        const response = await fetch(design.thumbnail_url);
        downloadedGangSheet = await response.blob();
      } catch (error) {
        this.$store.notifyError({
          message: "Failed to download gang sheet preview",
          error
        });

        this.$analytics.trackError("GangSheetPreviewDownloadError", error);
      }

      return downloadedGangSheet;
    }
  }
};
</script>
